export default "__VITE_ASSET__D1rNTiiw__"